import {Component} from 'react';
import h from 'react-hyperscript';
import './Benchmarking.scss';

class Benchmarking extends Component {
  render() {
    const {change, className} = this.props;
    const isNeg = change < 0;
    const isPos = change > 0;
    const classes = [
      className,
      'benchmarking',
      isNeg ? 'benchmarking--is-negative' : null,
      isPos ? 'benchmarking--is-positive' : null,
    ].filter(Boolean).join(' ');

    return (
      h('div', {
        className: classes,
      }, isNeg || isPos ? this.renderFigure() : this.renderZero())
    );
  }

  renderZero() {
    return [
      h('div', {
        className: 'benchmarking__none',
      }),
    ];
  }

  renderFigure() {
    const {change} = this.props;
    return [
      h('div', {
        className: 'benchmarking__arrow',
      }),
      h('p', {
        className: 'benchmarking__figure text--bold',
      }, Math.abs(change)),
    ];
  }
}

export default Benchmarking;
